











import { Component, Prop, Vue } from 'vue-property-decorator';

import { requestAction } from '@/api/resources/recurrence';

import FullTemplate from '@/shared/components/Template/Full.vue';
import Feedback from '@/shared/components/Template/Feedback.vue';

@Component
export default class Recurrence extends Vue {
  @Prop({ required: true }) readonly icon!: string;

  @Prop({ required: true }) readonly message!: string;
}
